const actions = {
  SET_STATE: 'interstate/SET_STATE',
  REFRESH_ERRORS: 'interstate/REFRESH_ERRORS',
  ALL: 'interstate/ALL',
  FETCH_ALL: 'interstate/FETCH_ALL',
  FETCH_MEMBERS_ALL: 'interstate/FETCH_MEMBERS_ALL',
  FETCH_CONTACTS_ALL: 'interstate/FETCH_CONTACTS_ALL',
  FETCH_PARENTS_ALL: 'interstate/FETCH_PARENTS_ALL',
  EXPORT: 'interstate/EXPORT',
  EXPORT_MEMBERS: 'interstate/EXPORT_MEMBERS',
  EXPORT_CONTACTS: 'interstate/EXPORT_CONTACTS',
  EXPORT_PARENTS: 'interstate/EXPORT_PARENTS',
  PRINT: 'interstate/PRINT',
  REFRESH_PRINT: 'interstate/REFRESH_PRINT',
  PRINT_MEMBERS: 'interstate/PRINT_MEMBERS',
  PRINT_CONTACTS: 'interstate/PRINT_CONTACTS',
  PRINT_PARENTS: 'interstate/PRINT_PARENTS',
  REFRESH_MEMBERS_PRINT: 'interstate/REFRESH_MEMBERS_PRINT',
  REFRESH_CONTACTS_PRINT: 'interstate/REFRESH_CONTACTS_PRINT',
  REFRESH_PARENTS_PRINT: 'interstate/REFRESH_PARENTS_PRINT',
  EMAILS: 'interstate/EMAILS',
  EMAILS_CONFIRMATION: 'interstate/EMAILS_CONFIRMATION',
  REFRESH_EMAILS: 'interstate/REFRESH_EMAILS',
  DETAILS: 'interstate/DETAILS',
  ADD: 'interstate/ADD',
  EDIT: 'interstate/EDIT',
  REMOVE: 'interstate/REMOVE',
  CHANGE_IS_DEACTIVATED: 'interstate/CHANGE_IS_DEACTIVATED'
};

export default actions
